export var DEPLOY_DATE = new Date('2026-04-10T10:31:32+0000');
